import React, { Component } from 'react';
import TitleOrderHeader from "../common/titleOrderHeader";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ToasterComponent from '../common/toaster';
import axios from 'axios';
import { URL, merFormHtmlTemplate } from '../../constants/constant';
import { _axios } from '../../plugins/axios';

class AddMerData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitBtnDisabled: false,
            messageSnacks: '',
            showSnackbar: false,
            FormFields: {
                height: 0,
                weight: 0,
                BPSystolic: 0,
                BPDiastolic: 0
            },
            orderDetails: this.props.filteredOrders?.pendingOrders?.[0],
            isABHI: this.props.isABHI
        }
    }

    handleBack = (isMerFormCollected = false) => {
        this.props.handleGoBackFromMer(isMerFormCollected);
    }

    clearTheForm = () => {
        this.setState({
            FormFields: {
                height: 0,
                weight: 0,
                BPSystolic: 0,
                BPDiastolic: 0
            },
            submitBtnDisabled: false
        })
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        let tempFieldValues = { ...this.state.FormFields }
        tempFieldValues[name] = +value;

        this.setState({
            FormFields: tempFieldValues
        }, () => {
            this.checkFieldValidation(e)
        })
    }

    checkFieldValidation = (e) => {
        const { name, value } = e.target;

        if (value <= 0) {
            this.showSnackbarFun(`${name} should be positive`, 3000)
        }
        this.checkFormValidation();
    }

    checkFormValidation = () => {
        let disableSubmitBtn = true;
        const formFields = this.state.FormFields;
        for (const field in formFields) {
            if (formFields[field] <= 0)
                disableSubmitBtn = false
        }

        this.setState({
            submitBtnDisabled: disableSubmitBtn
        })
    }

    handleSubmit = async () => {
        try {
            let merFromInputs = this.state.FormFields;
            let heightInMeters = this.state.FormFields.height / 100;
            const bmi = (this.state.FormFields.weight) / (heightInMeters * heightInMeters);

            merFromInputs["bmi"] = +bmi?.toFixed(2);
            merFromInputs["orderId"] = this.state.orderDetails?.orderId;
            merFromInputs["phelboOrderId"] = this.state.orderDetails?.prOrderId;
            merFromInputs["nameOfTheEmployee"] = this.state.orderDetails?.patientDetails?.[0]?.name;
            merFromInputs["memberId"] = this.state.orderDetails?.patientDetails?.[0]?.employeeId;
            merFromInputs["mobileNumber"] = this.state.orderDetails?.patientDetails?.[0]?.phoneNumber;
            merFromInputs["requestId"] = this.state.orderDetails?.appointmentId;
            merFromInputs["contractId"] = 9716;
            merFromInputs["heading"] = this.state.isABHI ? "Aditya Birla Group Health Assessment" : "Vitals Health Assessment";
            merFromInputs["isABHI"] = this.state.isABHI;
            merFromInputs["dependantId"] = this.state.orderDetails?.dependantId;

            let payload = {
                htmlTemplate: merFormHtmlTemplate,
                params: merFromInputs
            }

            let response = await _axios.post(URL.dev_url + 'addMerFormData', payload)

            if (response?.data?.success) {
                this.setState({
                    messageSnacks: response.data.message,
                    showSnackbar: true,
                }, () => {
                    this.toastComponent();
                    setTimeout(() => {
                        this.handleBack(true);
                    }, 2000)
                })

            } else
                throw new Error(response.data.message);
        }
        catch (error) {
            this.setState({
                messageSnacks: "Something went wrong",
                showSnackbar: true,
            }, () => {
                this.toastComponent();
                setTimeout(() => {
                    this.handleBack(false);
                }, 2000)
            })
        }
        return;
    }

    showSnackbarFun(message, timeout) {
        this.setState({
            messageSnacks: message,
            showSnackbar: true
        }, () => {
            this.toastComponent();
        })
        setTimeout(() => {
            this.setState({
                messageSnacks: "",
                showSnackbar: false,
            })
        }, timeout)
    }

    toastComponent() {
        return <ToasterComponent show={this.state.showSnackbar ? this.state.showSnackbar : ''} message={this.state.messageSnacks ? this.state.messageSnacks : ''}></ToasterComponent>;
    }

    showForm() {
        return (
            <Form className="p-t-20 p-b-20" onSubmit={(e) => this.handleSubmit(e)}>
                <Row className="p-t-4 m-t-10">
                    <Col xs={12} md={6} lg={6}>
                        <Form.Control type="number" name='height' placeholder="Enter height in cms" value={this.state.FormFields.height || ''} onChange={(e) => this.handleChange(e)} />
                    </Col>
                    <Col xs={12} md={6} lg={6} className='mt-3 mt-sm-3 mt-md-0'>
                        <Form.Control type="number" name='weight' placeholder="Enter weight in kgs" value={this.state.FormFields.weight || ''} onChange={(e) => this.handleChange(e)} />
                    </Col>
                </Row>
                <Row className="p-t-4 m-t-10">
                    <Col xs={12} md={6} lg={6}>
                        <Form.Control type="number" name='BPSystolic' placeholder="Higher BP in mmHg - BP Systolic" value={this.state.FormFields.BPSystolic || ''} onChange={(e) => this.handleChange(e)} />
                    </Col>
                    <Col xs={12} md={6} lg={6} className='mt-3 mt-sm-3 mt-md-0'>
                        <Form.Control type="number" name='BPDiastolic' placeholder="Lower BP in mmHg - BP Diastolic" value={this.state.FormFields.BPDiastolic || ''} onChange={(e) => this.handleChange(e)} />
                    </Col>
                </Row>
            </Form>
        )
    }

    render() {
        return (
            <div className="order-details-dashboard">
                <div>
                    {this.state.showSnackbar && this.toastComponent()}
                </div>
                <div>
                    <TitleOrderHeader title="Collect MER Data" orderId={this.state.orderDetails?.prOrderId} patientName={this.state.orderDetails ? this.state.orderDetails?.patientDetails?.[0]?.name : null}></TitleOrderHeader>
                </div>
                <div>
                    <Container>
                        {this.showForm()}
                    </Container>
                </div>
                <Container>
                    <Row>
                        <div className="fixed-bottom p-l-15 p-r-15 p-t-4 p-b-5">
                            <div className="display-flex justify-content-space-between p-b-10">
                                <div className="width-48">
                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.handleBack()}>Back</button>
                                </div>
                                <div className="width-48">
                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.clearTheForm()}> Clear</button>
                                </div>
                            </div>

                            <div>
                                <Button type="submit" variant="primary" disabled={!this.state.submitBtnDisabled} size="lg" block className="border-curve-10" onClick={() => this.handleSubmit()}>
                                    Submit
                                </Button>
                            </div>

                        </div>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default AddMerData;